module.exports = __webpack_public_path__ + "img/imge5.4c6c0c32.png";